import { Dispatch, SetStateAction, useEffect } from 'react';
import { ReactSelectInstanceRefObject, TReactSelectOption } from '../../custom-react-select.types';
import handleScrollAfterSelect from './handle-scroll-after-select';

type Params = {
  setSelectedOptions: Dispatch<SetStateAction<TReactSelectOption[]>>;
  selectedOptions: TReactSelectOption[];
  value?: TReactSelectOption[];
  selectRef: ReactSelectInstanceRefObject;
};

const useAsControlledComponent = ({ value, selectRef, selectedOptions, setSelectedOptions }: Params) => {
  useEffect(() => {
    if (!value) return; // don't do anything here if it's not a controlled component

    // if controlled component, always update selected options with the value
    if (value) {
      setSelectedOptions(value);
    }
  }, [setSelectedOptions, value]);

  // for controlled components we auto scroll to end of list when adding a new item
  useEffect(() => {
    if (!value) return; // don't do anything here if it's not a controlled component
    if (value.length > selectedOptions.length) {
      // if we get a new item, scroll to the end
      handleScrollAfterSelect({ selectRef });
    }
  }, [value, selectedOptions.length, selectRef]);
};

export default useAsControlledComponent;
